import { Button, Progress } from "nq-component";
import Table from "../../../../components/Table";
import CardView from "../../../../components/common/CardView";
import BaseListPage from "../../../../base/BaseListPage";
import Presenter from "../../../HumanResource/Employees/forms/DropdownTable/Presenter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";

export default class UserModal extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new Presenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { objects: [], count: 0, limit: 10, current: 1 };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "devices";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const isMobile = window.innerWidth <= 768;

    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;

    return (
      <>
        <div
          className="w-100 h-100 position-fixed end-0 start-0 overflow-y-auto d-flex justify-content-center align-items-center top-0"
          style={{
            zIndex: 1051,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          }}
        >
          {/* Existing modal content */}
          <div
            className="w-100 d-flex column align-items-end"
            style={{
              //   maxHeight: "99%",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: isMobile ? "90%" : "20rem",
                height: "100vh",
              }}
            >
              <CardView style={{ padding: 0, borderRadius: 0 }}>
                <h4 className="fs-6 fw-bold pt-3 ps-3">Registered Accounts</h4>
                <hr />
                <div
                  className="w-100 pt-3"
                  style={{
                    padding: "0 1.5rem",
                    flexGrow: 1, // This makes the table content grow and take available space
                    overflowY: "auto",
                  }}
                >
                  <Table
                    // objectData={this.handleSelect.bind(this)}
                    progress={loading}
                    //   refetch={this.refetchData.bind(this)}
                    fields={schema.fields}
                    objects={objects}
                    collection={schema}
                    count={count}
                    limit={limit}
                    current={current}
                    loadPagination={this.onClickPagination.bind(this)}
                    actionsList={[
                      {
                        label: (
                          <div className="h-auto w-auto text-center">
                            SELECT
                          </div>
                        ),
                        actionType: "object",
                      },
                    ]}
                    // selectable
                    // collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      ["Id", "Created At", "Updated At"]
                    )}
                    onClickItem={this.onClickItem.bind(this)}
                  />
                </div>
                <hr />
                <div className="w-100 d-flex justify-content-end align-items-baseline gap-4 mb-3 pe-3">
                  <Button
                    className="btn btn-light fs-sm"
                    onClick={() => this.props.closeSelectModal()}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-primary"
                    // onClick={this.handleClickOk.bind(this)}
                  >
                    OK
                  </Button>
                </div>
              </CardView>
            </div>
          </div>
        </div>
      </>
    );
  }
}
